export const checkEmptyDetails = (data) => {
  let flag = false;
  let key;

  for (key in data) {
    const item = data[key];
    if (typeof item !== 'object') {
      flag = !!item;
    } else flag = checkEmptyDetails(item);
    if (flag) break;
  }

  return flag;
};

export const getOrgTypeData = (profileData) => {
  let type;
  if (profileData.organisationType && profileData.organisationType.id &&
    profileData.organisationType.id === 'SHIPPER') {
    type = profileData.shipper;
  }
  if (profileData.organisationType && profileData.organisationType.id &&
    profileData.organisationType.id === 'FF') {
    type = profileData.ff;
  }
  return type;
};

export const checkAndAppendHttpToken = (url: string) => {
  if (!url) {
    return '';
  }
  if (url.includes('http')) {
    return url;
  }
  return `//${url}`;
};

export enum locationPreferences {
  FACTORY = 'Factory',
  CFS = 'CFS',
}

export enum ActionTypes {
  UPLOAD = 'UPLOAD',
  UPDATE = 'UPDATE'
}